module.exports = __webpack_public_path__ + "img/login-icon3.4445a6be.png";